module.exports = __webpack_public_path__ + "static/media/swc_logo.24accc6f.svg";